import { ICellRendererParams } from 'ag-grid-community';
import { range } from 'lodash';
import AnimateLoader from "../loaders/animate-loader.component";
import GridCellLoaderAminationData from "../loaders/grid-cell-loader.json";

interface Props extends ICellRendererParams {
}

const CustomLoadingOverlay = (props: Props) => {
    return (
        <div className="d-flex flex-wrap o-y-hidden" >{
            range(1, 10).map(x => <div key={x} className="d-flex grid-row disable-hover">
                <AnimateLoader LoaderAnimation={GridCellLoaderAminationData} className="m-1 h-v-3 w-v-100" />
            </div>)
        }
        </div>
    )
}

export default CustomLoadingOverlay